// eslint-disable-next-line import/no-named-as-default
import DOMPurify from 'dompurify';
/**
 * Detects URLs in text and converts them to clickable links.
 * The URL is displayed as the link text.
 *
 * @param text - The text potentially containing URLs
 * @returns React nodes with URLs converted to anchor tags
 */
export const embedURLsInText = (text: string) => {
  const urlInTextRegex = /(https?:\/\/[^\s]+)/g;
  const sanitizedText = DOMPurify.sanitize(text);

  const parts = sanitizedText.split(urlInTextRegex);

  const formattedText = parts.map((part, index) =>
    urlInTextRegex.test(part) ? (
      <a key={index} href={part} target="_blank" rel="noopener noreferrer">
        {part}
      </a>
    ) : (
      part
    ),
  );

  return formattedText;
};
